import { render, staticRenderFns } from "./AnnotationRow.vue?vue&type=template&id=01ac33c5&scoped=true&"
import script from "./AnnotationRow.vue?vue&type=script&lang=js&"
export * from "./AnnotationRow.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_annotations.scss?vue&type=style&index=0&id=01ac33c5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ac33c5",
  null
  
)

export default component.exports